class AuthUtils {
  static getOnboardingReturnUrl() {
    const currentUrl = new URL(window.location.href);
    return currentUrl.href;
  }
}
export {
  AuthUtils
};
//# sourceMappingURL=AuthUtils.js.map
